import { useQuery } from "@tanstack/react-query";
import { useOspApiClientProvider } from "@/src/hooks/useOspApiClientProvider";
import type { PositionBroker } from "@features/api/memberApi";

export interface UsePositionBrokersOptions {
  channel?: "plaid" | "snaptrade";
  institutionType?: "INVEST" | "BANKING";
  enabled?: boolean;
}

export const usePositionBrokers = (options: UsePositionBrokersOptions = {}) => {
  const { channel = "plaid", institutionType, enabled = true } = options;
  const { memberApi } = useOspApiClientProvider();

  return useQuery<PositionBroker[]>({
    queryKey: ["positionBrokers", channel, institutionType],
    queryFn: async () => {
      if (!memberApi) {
        return [];
      }
      const res = await memberApi.positions.getPositionBrokers({
        channel,
        ...(institutionType ? { institutionType } : {}),
      });
      return res?.data?.data || [];
    },
    enabled: Boolean(memberApi) && enabled,
    staleTime: 5 * 60 * 1000,
  });
};
